import React from "react";
import styles from './ContactUs.module.css';

interface Props{
    name:string,
    value:string,
    label?:string,
    placeholder?:string,
    onInputChange: Function,
    required?:boolean,
    options: {
        value: string,
        text: string
    }[],
    template: string
}

const RadioInput = ({name, label, placeholder, onInputChange, options, required, value, template}: Props) => {

    return <label className={styles.TextInputLabel}>{label}
            <div className={styles.RadioButtonContainer}>
                {options.map((option) => {
                    return <label key={option.value} htmlFor={option.value}>
                        <div className={`${styles.RadioButton} ${ option.value == value ? template === "basic" ? styles.activeIcon : styles.activeBasic : template ? template : "basic" ? styles.Icon : styles.basic }`} >
                                {template && template == "icon" && <div className={styles.RadioIconContainer}><div className={`${styles.RadioIcon} ${option.value === value ? styles.activeCircle : ''}`}></div></div>}
                                <div className="mediumText">{option.text}</div>
                               <input className={styles.RadioButtonElement} hidden={true} checked={option.value == value ? "checked" : ""} id={`${option.value}`} type="radio" name={name} value={option.value} placeholder={placeholder} onChange={(e) => onInputChange ? onInputChange(e.target.value) : null} required={required}/>
                         </div>
                    </label>
                })}
            </div>
        </label>

}

export default RadioInput;

